import { DetailProps } from '../preFlight/types';

/** Bell kinds the avaliahub knows how to show (the back-end has more). */
export enum NotificationKind {
  /** The source (RPAM) sent a report version back; resource = preflight request. */
  PREFLIGHT_REPORT_RETURNED = 'PREFLIGHT_REPORT_RETURNED',
  /** A Preenchimento pair became critical; resource = the day's snapshot. */
  RECRUITMENT_CELL_CRITICAL = 'RECRUITMENT_CELL_CRITICAL',
}

/** `resource` of RECRUITMENT_CELL_CRITICAL: the pair to open. */
export interface RecruitmentAlertResource {
  id: number;
  notice_id: number;
  notice_coverage_id: number;
  criteria_group_id: number;
  snapshot_date: string;
  diagnosis: string;
  severity: number;
}

export interface NotificationData {
  id: number;
  kind: NotificationKind | string;
  user_id: number;
  resource_id: number;
  company_id: number | null;
  title: string;
  is_read: boolean;
  created_at: string;
  updated_at: string;
  /** Kind-specific payload built by the back-end (scalar columns only). */
  resource?: Record<string, unknown> | null;
}

export interface GetNotificationsProps extends DetailProps {
  data?: NotificationData[];
}

export interface MarkNotificationsProps extends DetailProps {
  data?: unknown;
}
